import { connect } from 'react-redux';
import { getLocation } from './selectors';

export function mapStateToProps(state) {
    return {
        location: getLocation(state),
    };
}

/**
 * This exists because react-router doesn't retain any information about the
 * domain context of the page you're on. It's only concerned with /path, which
 * is too anemic for our needs in a multi domain + environment context.
 */
export default function withLocation(WrappedComponent) {
    return connect(mapStateToProps)(WrappedComponent);
}
